import Icon from '../components/Icon.vue'

Icon.register({
  'mobile-alt': {
    width: 320,
    height: 512,
    paths: [
      {
        d: 'M272 0H48C21.5 0 0 21.5 0 48V464C0 490.5 21.5 512 48 512H272C298.5 512 320 490.5 320 464V48C320 21.5 298.5 0 272 0zM160 480C142.3 480 128 465.7 128 448S142.3 416 160 416 192 430.3 192 448 177.7 480 160 480zM272 372C272 378.6 266.6 384 260 384H60C53.4 384 48 378.6 48 372V60C48 53.4 53.4 48 60 48H260C266.6 48 272 53.4 272 60V372z'
      }
    ]
  }
})
